export const constructStrRep = (obj) => {
  return obj.id || "Kravprofil";
};
export const detailUrl = ({ id }) => {
  return `/market/requirements/detail/${id}`;
};
export const overviewUrl = () => {
  return `/market/requirements`;
};
